/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const SenderFirstNameColumnFormatter = (cellContent, row, rowIndex) => {
  const { senderFirstName } = row;

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {senderFirstName ? senderFirstName : `-`}
      </div>
      <> </>
    </>
  );
};
